'use strict';

module Search {

    class InputWithIcon {

        // Attr
        iconName: string;
        addToggle: boolean;

        private eventNamespace = 'inputwithicon';
        private active: boolean = false;
        private wrapper: JQuery;

        constructor (
            private $scope: ng.IScope
        ) {
        }

        init (el: JQuery): void {

            let input = el.find('input');

            //this.iconName && el.addClass('icon-' + this.iconName);
            this.addToggle && el.addClass('toggle');

            if (this.iconName) {
                el.prepend('<span class="field-icon icon-' + this.iconName + '"></span>');
            }

            input.on('focus.' + this.eventNamespace, () => {
                    this.$scope.$apply(() => {
                        el.addClass('with-focus');
                    });
                }).on('blur.' + this.eventNamespace, () => {
                    this.$scope.$apply(() => {
                        el.removeClass('with-focus');
                    });
                });

            this.$scope.$on('$destroy', () => {
                // unbind event listeners by namespace
                input.off('.' + this.eventNamespace);
            });

        }
    }

    angular
        .module('search')
        .directive('inputWithIcon', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                transclude: true,
                template: `<div class="input-with-icon" 
                            ng-class="{'no-icon': iwi.iconName === ''}" ng-transclude />`,
                controller: InputWithIcon,
                controllerAs: 'iwi',
                bindToController: {
                    iconName: '@',
                    addToggle: '='
                },
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller : InputWithIcon
                ) => {
                    controller.init(el);
                }
            };
        });


}
